import { jsx as _jsx } from "react/jsx-runtime";
import augmentArrayFunctionKey from "../../../common-utils/array/arrayAugmentFunctionKey.util.js";
import insertIf from "../../../common-utils/object/objectInsertIf.util.js";
// import hooks
import { useState } from "react";
import useMediaQuery from "../../../hooks/useMediaQuery/index.js";
import useDeploymentEnvironment from "../../../hooks/useDeploymentEnvironment/index.js";
import { SINGLE } from "../../../constants/numbers.consts.js";
import AppSwitcherMenu from "../../../components/molecules/AppSwitcherMenu/index.js";
import ProfileMenu from "../../../components/molecules/ProfileMenu/index.js";
import NotificationMenu from "../../../components/molecules/NotificationMenu/index.js";
import MobileMenu from "../../../components/molecules/MobileMenu/index.js";
import titleDefaults from "../../../translate/defaults/title.defaults.js";
export const useAppBar = ({ appSwitcher, notifications, profile, mobileMenu, translations, }) => {
    const isSmallScreen = useMediaQuery(({ breakpoints }) => breakpoints.down("expanded"));
    const deploymentEnvironment = useDeploymentEnvironment();
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [drawerType, setDrawerType] = useState("appswitcher");
    const drawerCorners = drawerType === "appswitcher" ? "right" : "left";
    const appSwitcherButtonIsActive = drawerOpen && drawerType === "appswitcher";
    const { slotProps, ..._mobileMenu } = { ...mobileMenu };
    // Drawer
    const toggleAppSwitcherDrawerHandler = () => {
        if (!isSmallScreen && !!appSwitcher?.data && appSwitcher.data.length === SINGLE) {
            appSwitcher.onClickOneApplication && appSwitcher.onClickOneApplication();
            return;
        }
        setDrawerType("appswitcher");
        setDrawerOpen((_drawerOpen) => !_drawerOpen);
    };
    const openDrawerHandler = (_drawerType) => {
        setDrawerType(_drawerType);
        if (_drawerType === "appswitcher" && !appSwitcher?.data?.length) {
            setDrawerOpen(false);
        }
        else {
            setDrawerOpen(true);
        }
    };
    const closeDrawerHandler = () => setDrawerOpen(false);
    const drawerAnchor = drawerType === "appswitcher" ? "left" : "right";
    const drawerContentsAppswitcher = (_jsx(AppSwitcherMenu, { ...appSwitcher, header: {
            ...appSwitcher?.header,
            title: appSwitcher?.header?.title ?? translations?.applicationTitle ?? titleDefaults.applications,
        } }));
    const augmentArrayFunctionOptions = {
        keyName: ["payload", "onClick"],
        excludeKey: "disableCloseOnPayload",
        augmentAction: closeDrawerHandler,
    };
    const drawerContentsNotifications = (_jsx(NotificationMenu, { ...notifications, data: augmentArrayFunctionKey(notifications?.data, augmentArrayFunctionOptions), header: {
            ...notifications?.header,
            title: notifications?.header?.title ?? translations?.notificationsTitle ?? titleDefaults.notifications,
            closeButtonProps: { onClick: closeDrawerHandler },
        } }));
    const drawerContentsProfile = (_jsx(ProfileMenu, { ...profile, data: augmentArrayFunctionKey(profile?.data, augmentArrayFunctionOptions), header: {
            ...profile?.header,
            title: profile?.header?.title ?? translations?.profileTitle ?? titleDefaults.profile,
            closeButtonProps: { onClick: closeDrawerHandler },
        } }));
    const drawerContentsMobileMenu = (_jsx(MobileMenu, { ..._mobileMenu, data: augmentArrayFunctionKey(_mobileMenu.data, augmentArrayFunctionOptions), selectedId: _mobileMenu.selectedId, footer: {
            ...insertIf(!!appSwitcher?.data && appSwitcher.data.length > SINGLE, { appSwitcher }),
            actionButton: slotProps?.actionButton,
        } }));
    const drawerContents = {
        appswitcher: isSmallScreen ? drawerContentsMobileMenu : drawerContentsAppswitcher,
        notifications: drawerContentsNotifications,
        profile: drawerContentsProfile,
    };
    // Notifications handler
    const openNotificationsHandler = () => {
        if (notifications?.overwriteClick) {
            notifications.overwriteClick();
        }
        else {
            openDrawerHandler("notifications");
            if (notifications?.onOpenNotifications) {
                notifications?.onOpenNotifications();
            }
        }
    };
    // Profile handler
    const openProfileHandler = () => {
        if (profile?.overwriteClick) {
            profile.overwriteClick();
        }
        else {
            openDrawerHandler("profile");
        }
    };
    const drawerContent = drawerContents[drawerType];
    return {
        drawerContent,
        drawerAnchor,
        drawerOpen,
        drawerCorners,
        appSwitcherButtonIsActive,
        deploymentEnvironment,
        toggleAppSwitcherDrawerHandler,
        openNotificationsHandler,
        openProfileHandler,
        closeDrawerHandler,
    };
};
export default useAppBar;
